import { palletService } from "../../../../front-office/services/pallet";
import { GetPalletsByStatusQuery } from "./get-pallets-by-status-query";

export const GetPalletsByStatusHandler = async (query: GetPalletsByStatusQuery) => {
    return palletService.loadPallets(query.warehouseCode, query.status);
};
